export default "__VITE_ASSET___app/immutable/assets/logotype.CAx-nu9G.svg__"